module.exports = "<template><span if.bind=value style=word-wrap:break-word innerhtml.bind=\"value | shrink:column.maxContentLength\"></span></template> ";